/* WristBear delivery dates (signed-off design: product page + cart).
   Asia/Dubai time, same-day dispatch before the cut-off on dispatch days, UAE arrival after
   min–max business days, skipping courier days off and owner-listed holidays. Rendered once;
   no ticking timer. Without JS the static sentence in the markup stays. */
(() => {
  const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  // Day lists are free text in the editor: drop anything that is not a day number 0-6.
  const nums = (s) => String(s || '').split(',').map((x) => parseInt(x, 10)).filter((n) => Number.isInteger(n) && n >= 0 && n <= 6);
  const CAP = 60;
  const iso = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  const fmt = (d) => DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()];

  function dubaiNow() {
    const p = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Dubai', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    const g = (t) => Number(p.find((x) => x.type === t).value);
    return { date: new Date(g('year'), g('month') - 1, g('day')), hour: g('hour') + g('minute') / 60 };
  }

  function estimate(el) {
    const cutoff = Number(el.dataset.cutoff || 17);
    let dispatchDays = nums(el.dataset.dispatchDays);
    if (!dispatchDays.length) dispatchDays = [1, 2, 3, 4, 5, 6];
    const skipDays = nums(el.dataset.skipDays);
    const holidays = String(el.dataset.holidays || '').split(',').map((x) => x.trim()).filter(Boolean);
    let min = Number(el.dataset.min || 1);
    let max = Number(el.dataset.max || 3);
    if (min > max) [min, max] = [max, min];
    const isOff = (d, days) => !days.includes(d.getDay()) || holidays.includes(iso(d));

    const now = dubaiNow();
    const ship = new Date(now.date);
    const today = !isOff(ship, dispatchDays) && now.hour < cutoff;
    if (!today) {
      let i = 0;
      do { ship.setDate(ship.getDate() + 1); i++; } while (isOff(ship, dispatchDays) && i < CAP);
      if (i >= CAP) return null;
    }
    const deliveryDays = [0, 1, 2, 3, 4, 5, 6].filter((d) => !skipDays.includes(d));
    const add = (n) => {
      const d = new Date(ship);
      let k = 0;
      let i = 0;
      while (k < n && i < CAP) { d.setDate(d.getDate() + 1); i++; if (!isOff(d, deliveryDays)) k++; }
      return k < n ? null : d;
    };
    const from = add(min);
    const to = add(max);
    if (!from || !to) return null;
    return { today, ship, from, to };
  }

  const hourLabel = (h) => (h % 12 || 12) + (h >= 12 ? ' PM' : ' AM');

  function render(root = document) {
    root.querySelectorAll('[data-wb-delivery]').forEach((el) => {
      if (el.dataset.showDates !== 'true') return;
      const line = el.querySelector('[data-wb-delivery-line]');
      if (!line) return;
      const e = estimate(el);
      if (!e) return; // settings could not produce a date: keep the static sentence
      const lead = e.today
        ? 'Order before ' + hourLabel(Number(el.dataset.cutoff)) + ' today (UAE time) and it arrives'
        : 'Order now, it ships ' + DAYS[e.ship.getDay()] + ' and arrives';
      const strong = line.querySelector('strong');
      line.textContent = '';
      if (strong) { line.appendChild(strong); line.appendChild(document.createTextNode(' ')); }
      line.appendChild(document.createTextNode(lead + ' '));
      const b = document.createElement('strong');
      b.textContent = fmt(e.from) + ' – ' + fmt(e.to);
      line.appendChild(b);
      line.appendChild(document.createTextNode(' in the UAE.'));
    });
    root.querySelectorAll('[data-wb-eta]').forEach((el) => {
      // International keeps the wb_intl_text wording; only UAE rows get dates.
      if (el.dataset.showDates !== 'true' || el.dataset.wbEta === 'intl') return;
      const e = estimate(el);
      if (!e) return;
      el.textContent = 'Arrives ' + fmt(e.from) + ' – ' + fmt(e.to);
    });
  }

  window.WBDelivery = { render };
  // Cart drawer, cart page and product info are re-rendered by the theme after each change:
  // watch only those containers and render new nodes once.
  const SCOPES = '#CartDrawer, main-cart, product-info';
  const TARGETS = '[data-wb-eta],[data-wb-delivery]';
  const observer = new MutationObserver((recs) => {
    for (const r of recs) for (const n of r.addedNodes) {
      if (n.nodeType !== 1) continue;
      if (n.matches(TARGETS) || n.querySelector(TARGETS)) render(n.parentElement || n);
      if (n.matches(SCOPES) || n.querySelector(SCOPES)) watch(n.parentElement || n);
    }
  });
  const watch = (root = document) => root.querySelectorAll(SCOPES).forEach((el) => observer.observe(el, { childList: true, subtree: true }));
  // A full product swap replaces <main> directly under <body>: catch that without watching the whole tree.
  observer.observe(document.body, { childList: true });
  watch();
  render();
  document.addEventListener('shopify:section:load', (e) => { watch(e.target); render(e.target); });
})();
